import { ClubBookingApiClient } from "../../common/api/ClubBookingApiClient";
import { CurrentStaff, StaffUser } from "../../model/members/StaffUser";

function normalizeStaffUserFromApi(raw: Record<string, unknown>): StaffUser {
  return {
    id: Number(raw.id ?? 0),
    name: String(raw.name ?? ""),
    isActive: raw.isActive == null ? true : Boolean(raw.isActive),
  };
}

export class StaffUserService extends ClubBookingApiClient {
  async getStaffUsers(): Promise<StaffUser[]> {
    try {
      const raw = await this.get<Record<string, unknown>[]>("/staff/users");
      return Array.isArray(raw) ? raw.map(normalizeStaffUserFromApi) : [];
    } catch (error) {
      console.error("Error getting staff users:", error);
      throw error;
    }
  }

  /**
   * Who the API considers the caller to be.
   *
   * Returns null only when the question could not be *asked* — a 500, a dropped
   * connection, an expired token. "Nobody is signed in on this device" is a successful
   * answer with `staff: null`, which the API deliberately returns as a 200. Callers must
   * keep the two apart: acting on a transport failure as though it meant "not signed in"
   * would wipe a valid selection off every reception desk during a deploy blip.
   */
  async getCurrentStaff(): Promise<CurrentStaff | null> {
    const raw = await this.get<CurrentStaff | undefined>("/dashboard/me", undefined, {
      showLoading: false,
    });
    if (raw == null) return null;
    const staff = raw.staff;
    return {
      staff: staff == null ? null : { id: Number(staff.id), name: String(staff.name) },
      fromLogin: Boolean(raw.fromLogin),
    };
  }
}
